import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <p className="footer-text">
          Tailor is free and open source under the{' '}
          <a
            href="https://github.com/DickonC/shop-with-tailor/blob/main/LICENSE"
            target="_blank"
            rel="noopener noreferrer"
          >
            MIT License
          </a>
        </p>
        <p className="footer-links">
          <a
            href="https://github.com/DickonC/shop-with-tailor"
            target="_blank"
            rel="noopener noreferrer"
          >
            GitHub
          </a>
          <span className="footer-sep">&middot;</span>
          <Link to="/privacy">Privacy Policy</Link>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
